export function scheduleSummary(calendars, error, presenceById, formatDate) {
  if (error) return { text: 'График временно недоступен', color: 'neutral' };
  if (!calendars.length) return { text: 'График пока не подключён', color: 'neutral' };
  if (calendars.length > 1) {
    const count = calendars.filter((item) => item.status === 'on_shift').length;
    const missing = calendars.some((item) => item.status === 'unknown');
    return { text: `Врачей: ${calendars.length} · на смене: ${count}${missing ? ' · есть неизвестный график' : ''}`, color: 'neutral' };
  }
  const doctor = calendars[0];
  const offline = doctor.profile_id != null && presenceById[doctor.profile_id] === false;
  const suffix = offline ? ' · не в сети' : '';
  if (doctor.status === 'unknown') return { text: `График пока недоступен${suffix}`, color: 'neutral' };
  if (doctor.status === 'on_shift') return { text: `Рабочая смена${suffix}`, color: 'success' };
  return {
    text: `Вне смены${suffix}${doctor.next_start ? ` · ближайшая ${formatDate(doctor.next_start)}` : ''}`,
    color: 'neutral',
  };
}